<template>
  <b-modal id="modal-impressao-certidao-eletronica"
           ref="modal-impressao-certidao-eletronica"
           :content-class="zoomClass"
           size="xl">
    <template>
      <div class="boxDocs BoxCertidaoEletronica">
        <object v-if="impressao.urlPDFCertidao"
                :key="impressao.urlPDFCertidao"
                class="embed-preview embed-responsive"
                :data="impressao.urlPDFCertidao"
                type="application/pdf">
          <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
        </object>
      </div> 
    </template>

    <object v-if="tipo=='habilitacao' && propFilePreview != null"
            class=""
            style="height: 296mm; width: 80vh;"
            :data="`${propFilePreview }#toolbar=0&navpanes=0&scrollbar=0`"
            type="application/pdf">
      <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
    </object>

    <template v-slot:modal-header>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            :disabled="zoom < 1"
            @click="zoom--">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomMinus" />
          </b-button>
          <b-button
            size="sm"
            class="ml-2 mr-2"
            variant="primary"
            :disabled="zoom > 1"
            @click="zoom++">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomPlus" />
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="default"
            @click="$bvModal.hide('modal-impressao-certidao-eletronica')">
            <icon-svg class="impressao_documento--icon icon--xs"
                      icon="close" />
          </b-button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            variant="default"
            class="mr-2"
            @click="$bvModal.hide('modal-impressao-certidao-eletronica')">
            Voltar
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="assinarCertidaoEletronica()">
            Assinar Certidão
          </b-button> 
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  /* components */
  import FrenteImpressaoNascimento from "./Templates/FrenteImpressaoNascimento"
  import VersoImpressao from "./Templates/VersoImpressao"

  export default {
    name: "ModalCertidao",
    components: {
      VersoImpressao,
      FrenteImpressaoNascimento,
    },
    props: {
      data: Object,
      tipo: String,
      propFilePreview: String
    },
    data () {
      return {
        optionsOrgaoEmissor: [],
        certidaoVerso: false,
        impressao: {},
        zoom: 0,
        visualizarFrenteImpressao: false
      }
    },
    computed: {
      zoomClass: function () {
        let className = ''

        switch (this.zoom) {
        case 2:
          className = 'modalZoom--2'
          break
        case 1:
          className = 'modalZoom--1'
          break
        case 0:
          className = ''
          break
        }

        return className
      }
    },
    watch: {
      data () {
        this.impressao = {...this.data}
      },
      'data.emolumentos': function () {
        this.impressao = { ...this.data }
      }
    },
    beforeMount () {
      this.impressao = {...this.data}
    },
    methods: {
      assinarCertidaoEletronica () {
        this.$emit('onAssinar', this.data.certidaoEletronicaId)
      }
    }
  }
</script>

<style lang="scss">
@import "@/scss/_utilities/_exports.scss";
@import "@/scss/_components/_modals.scss";
@import "@/scss/_components/_modalCertidao.scss";

  .CertidaoEletronica {
    border: 1px solid black;
    width: 100%;
  }
  .Certidao-eletronica-pdf {
    width: 210mm;
    min-height: 297mm;
  }
  .BoxCertidaoEletronica {
    padding-top: 0%;
  }

</style>
